module.exports = __webpack_public_path__ + "img/barbara.900d82f.jpeg";